import {connect} from 'react-redux';
import {createTemplateCategory, loadTemplateCategoryList, searchTemplate, selectTemplateCategory} from 'template/actions';
import React, {Component, Fragment} from 'react';
import autobind from 'autobind-decorator';
import {Button, Input, Label} from 'reactstrap';
import Dialog from 'apa/containers/Dialog';

@connect(
    state => ({
        templateCategoryList: state.template.templateCategoryList
    }),
    dispatch => {
        return {
            loadCategoryList: () => dispatch(loadTemplateCategoryList()),
            selectCategory: (category) => dispatch(selectTemplateCategory(category)),
            createManualCategory: (category) => dispatch(createTemplateCategory(category)),
            searchManual: (searchText) => dispatch(searchTemplate(searchText))
        }
    }
)
export default class NewTemplateCategory extends Component {

    constructor() {
        super();
        this.state = {
            isOpen: false,
            newTemplateCategoryName: ''
        }
    }

    @autobind
    toggle() {
        this.setState({isOpen: !this.state.isOpen})
    }

    @autobind
    confirmNewManualCategory() {
        this.props.createManualCategory({name: this.state.newTemplateCategoryName})
        this.toggle()
    }

    @autobind
    setNewTemplateCategoryName(name) {
        this.setState({newTemplateCategoryName: name})
    }

    render() {
        return (
            <Fragment>
                <Button color='primary' onClick={this.toggle}>Neue Kategorie anlegen</Button>
                <Dialog
                    isOpen={this.state.isOpen}
                    confirm={this.confirmNewManualCategory}
                    toggle={this.toggle}
                    title={'Neue Kategorie anlegen'}
                >
                    <Fragment>
                        <Label>
                            Name
                        </Label>
                        <Input
                            type="text"
                            value={this.state.newTemplateCategoryName}
                            onChange={e => this.setNewTemplateCategoryName(e.target.value)}/>
                    </Fragment>
                </Dialog>
            </Fragment>
        )
    }
}
